import { render } from "./CookiePolicyContent.vue?vue&type=template&id=d85102ea&scoped=true"
const script = {}

import "./CookiePolicyContent.vue?vue&type=style&index=0&id=d85102ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d85102ea"]])

export default __exports__